import { useState } from 'react';
import { ButtonMain, Checkbox } from '@quero-delivery/quero-components-web';
import { createPortal } from 'react-dom';
import map from 'lodash/map';

import useModal from '@/hooks/util/useModal';

interface ModalCancelDeliveryProps {
  opened: boolean;
  onClose(): void;
  loading: boolean;
  disabled: boolean;
  onCancel(taxPayers: TaxPayerObj[]): void;
  isFinishedDelivery?: boolean;
}

type TaxPayer = 'PLACE' | 'MOTOBOY';

export interface TaxPayerObj {
  key: TaxPayer;
  text: string;
}

export const TAX_PAYER_OPTIONS: Record<TaxPayer, TaxPayerObj> = {
  PLACE: {
    key: 'PLACE',
    text: 'Cobrar do estabelecimento',
  },
  MOTOBOY: {
    key: 'MOTOBOY',
    text: 'Repassar ao entregador',
  },
};

function ModalCancelDelivery({
  opened,
  onClose,
  disabled,
  loading,
  onCancel,
  isFinishedDelivery,
}: ModalCancelDeliveryProps) {
  const [taxPayers, setTaxPayers] = useState<TaxPayerObj[]>(
    isFinishedDelivery
      ? []
      : [TAX_PAYER_OPTIONS.MOTOBOY, TAX_PAYER_OPTIONS.PLACE],
  );

  const Modal = useModal({ maxHeight: undefined });

  if (!opened) {
    return null;
  }

  return createPortal(
    <Modal
      open={opened}
      onClose={onClose}
      closeOnDimerClick
      title="Cancelar entrega"
      size="xs"
      loading={loading}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        {map(TAX_PAYER_OPTIONS, taxPayer => {
          const isActive = taxPayers.some(item => item.key == taxPayer.key);

          return (
            <Checkbox
              label={taxPayer.text}
              checked={isActive}
              disabled={loading || isFinishedDelivery}
              onChange={() => {
                const newTaxPayers = isActive
                  ? taxPayers.filter(item => item.key !== taxPayer.key)
                  : [...taxPayers, taxPayer];

                setTaxPayers(newTaxPayers);
              }}
            />
          );
        })}

        <ButtonMain
          secondary
          width="100%"
          textFirst="cancelar"
          firstStrong
          onClick={() => {
            onCancel(taxPayers);
            onClose();
          }}
          disabled={loading || disabled}
        />
      </div>
    </Modal>,
    document.body,
  );
}

export default ModalCancelDelivery;
